var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.50001C20.0989 5.5 20.1955 5.52933 20.2778 5.58426C20.36 5.6392 20.4241 5.71729 20.4619 5.80865C20.4998 5.90002 20.5097 6.00055 20.4904 6.09754C20.4711 6.19453 20.4235 6.28362 20.3536 6.35355L10.7071 16L20.3536 25.6465C20.4472 25.7403 20.4998 25.8674 20.4997 25.9999C20.4997 26.1325 20.447 26.2596 20.3533 26.3533C20.2595 26.447 20.1324 26.4997 19.9999 26.4998C19.8673 26.4998 19.7402 26.4472 19.6464 26.3536L9.64641 16.3535C9.55264 16.2598 9.49997 16.1326 9.49997 16C9.49997 15.8674 9.55264 15.7402 9.64641 15.6465L19.6464 5.64646C19.6928 5.59996 19.7479 5.56308 19.8086 5.53795C19.8693 5.51282 19.9343 5.49992 20 5.50001Z",
    fill: "#222229",
    stroke: "#222229",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftNew);
export default __webpack_public_path__ + "static/media/arrow-left-new.353140e5c9ae6852b3ed47daf8afc5f0.svg";
export { ForwardRef as ReactComponent };